import { Button, Menu, type MenuItem } from "@omnabase/ui";
import { columnParams, tabOnScreen, type ColumnTab } from "./ticketColumn";
import { useSetParam } from "../../lib/nav";

/** The ticket band's right group (the discussion polish round, 2026-11-02; trimmed in the composer-and-fixes round, 2026-11-03, brief rule 10):
 *  - **Customer** (the person icon) opens the customer column on its Profile tab: the drawer below 1600 px, the tab above; pressed while that
 *    tab shows, and clicking it then does nothing (Esc or × closes the drawer);
 *  - then the "…" menu only with what is left (today the knowledge base pair item on a resolved ticket).
 *  Discussion is reached through the reply bar's Discuss and the thread's condensed item, the AI's asks through the reply bar's AI menu. Every
 *  icon button carries its name as the spoken label and the kit's tooltip (`data-tip`), never the browser's `title`. */
export type ColumnState = { wide: boolean; open: boolean; tab: ColumnTab };
export type BandActionsProps = {
  column: ColumnState;
  /** what is left for the "…" menu */ more: MenuItem[];
};

export function TicketBandActions({ column, more }: BandActionsProps) {
  const setParam = useSetParam();
  const pressed = tabOnScreen("profile", column);
  const show = () => { const p = columnParams("profile", column.wide); setParam("tab", p.tab); setParam("info", p.info); };
  return (
    <>
      <Button variant="icon" icon="user" className="ob-ticket-bar__column" aria-label="Customer" data-tip="Customer" aria-pressed={pressed} active={pressed} onClick={() => { if (!pressed) show(); }} />
      {more.length > 0 && <Menu align="end" trigger={<Button variant="icon" icon="more" aria-label="More actions" data-tip="More actions" />} sections={[{ items: more }]} />}
    </>
  );
}
